<template>
  <ul>
    <li v-for="(modulo, idxModulo) in menu">
      <b-link href="#" v-b-toggle="'mod-' + idxModulo" data-toggle="collapse" class="dropdown-toggle">{{ modulo.titulo }}</b-link>
      <b-collapse :id="'mod-' + idxModulo" :visible="isModuloVisivel(modulo.referencia)" accordion="accordionModulos" role="tabpanel">
        <ul>
          <li v-for="(licao, idxLicao) in modulo.licoes">
            <b-link href="#" v-b-toggle="'#mod-' + idxModulo + '-licao-' + idxLicao" data-toggle="collapse" class="dropdown-toggle">{{ licao.titulo }}</b-link>
            <b-collapse :id="'#mod-' + idxModulo + '-licao-' + idxLicao" accordion="accordionLicoes" :visible="isLicaoVisivel(licao.referencia, modulo.referencia)" role="tabpanel">
              <ul>
                <template v-for="topico in licao.topicos">
                  <li id="lista3D" v-bind:class="{ active: isMenuActive(topico.href) }" v-if="topico.tipoTopico.e3D">
                    <a href="javascript:void(0)" @click="irParaTopico(topico)" :title="topico.titulo">
                      <img id="imagemIcone3DTopicoSelecionado" :src="caminhoImagem3DTopicoSelecionado" :class="topico.tipoTopico.icone" />
                      <img id="imagemIcone3DNoturno" :src="caminhoImagem3DModoNoturno" :class="topico.tipoTopico.icone" />
                      <img id="imagemIcone3D" :src="caminhoImagem3D" :class="topico.tipoTopico.icone" /> {{ topico.nomeAbreviado }} <i
                      class="fas fa-check-circle float-right" v-if="topico.concluido"></i></a>
                  </li>
                  <li v-bind:class="{ active: isMenuActive(topico.href) }" v-if="!topico.tipoTopico.e3D && (topico.tipo != 7 || (topico.tipo == 7 && licao.simulados.length == 0))">
                    <a href="javascript:void(0)" @click="irParaTopico(topico)" :title="topico.titulo">
                      <i :class="topicoIcone(topico)"></i>{{ topico.nomeAbreviado }}&nbsp;
                      <i class="fas fa-check-circle float-right" v-if="topico.concluido"></i>
                    </a>
                  </li>
                </template>
                 <template v-for="simulado in licao.simulados">
                  <li v-bind:class="{ active: isMenuActive('simulado-' + simulado.id) }">
                    <a href="javascript:void(0)" @click="irParaSimulado(modulo.referencia, licao.referencia, simulado.id)" :title="simulado.simulado">
                    <i class="fa fa-list-ul"></i>
                    {{ 'Quiz - ' +simulado.simulado }}
                    <i class="fas fa-check-circle float-right" v-if="simulado.concluido"></i></a>
                  </li>
                </template>
              </ul>
            </b-collapse>
          </li>
        </ul>
      </b-collapse>
    </li>
  </ul>
</template>

<script>
import TipoTopico, { TipoTopicoUtil } from '@/core/types/tipo-topico-licao'
import TipoLink, { TipoLinkUtil } from '@/core/types/tipo-link'
import Constants from '@/core/constants/constants'

export default {
  name: 'MenuLateralSalaAula',
  props: {
    modulos: Array,
    curso: Object
  },

  data () {
    return {
      menu: []
    }
  },

  watch: {
    modulos: function () {
      this.montaMenu()
    },
    '$store.getters.ementaIdConcluida': function () {
      this.montaMenu()
    }
  },
  computed: {
    caminhoImagem3D () {
      return `${process.env.VUE_APP_BASE_FILES_URL}img/heart-b2b.png?v=${process.env.PACKAGE_VERSION}`
    },
    caminhoImagem3DModoNoturno () {
      return `${process.env.VUE_APP_BASE_FILES_URL}img/heart-noturno.png?v=${process.env.PACKAGE_VERSION}`
    },
    caminhoImagem3DTopicoSelecionado () {
      return `${process.env.VUE_APP_BASE_FILES_URL}img/heart-b2b-branco.png?v=${process.env.PACKAGE_VERSION}`
    }
  },
  methods: {
    isModuloVisivel: function (referencia) {
      return this.$route.params.modulo === referencia
    },
    isLicaoVisivel: function (referenciaLicao, referenciaModulo) {
      return this.$route.params.licao === referenciaLicao && this.$route.params.modulo === referenciaModulo
    },
    isMenuActive: function (path) {
      return this.$route.path === path || this.$route.path === path + '/'
    },
    irParaTopico: function (topico) {
      const tipoTopico = TipoTopicoUtil.obterTipoTopicosPorId(topico.tipo)
      const tipoLink = TipoLinkUtil.obterPorCodigoInterno(topico.codigo_interno)

      if (tipoTopico === TipoTopico.LINK && tipoLink === TipoLink.EXTERNO) {
        window.open(topico.link_url, 'conteudo-link')
      }

      this.$router.push(topico.href)
    },
    irParaSimulado: function (referenciaModulo, referenciaLicao, simuladoId) {
      this.$router.push('/sala-de-aula/' + this.curso.referencia + '/' + referenciaModulo + '/' + referenciaLicao + '/' + 'simulado-' + simuladoId)
    },
    topicoIcone: function (topico) {
      const tipoTopico = TipoTopicoUtil.obterTipoTopicosPorId(topico.tipo)
      const tipoLink = TipoLinkUtil.obterPorCodigoInterno(topico.codigo_interno)

      if (tipoTopico === TipoTopico.LINK && tipoLink === TipoLink.EXTERNO) {
        return TipoTopico.LINK_EXTERNO.icone
      }
      return topico.tipoTopico.icone
    },
    montaMenu () {
      const modulos = this.modulos

      modulos.forEach((modulo, iModulo) => {
        modulo.licoes.forEach((licao, iLicao) => {
          let index = 1
          licao.topicos.forEach(topico => {
            if (topico.pivot.id === this.$store.getters.ementaIdConcluida) {
              topico.concluido = 1
            }

            if (topico.tipo) {
              const tipoTopico = TipoTopicoUtil.obterTipoTopicosPorId(topico.tipo)
              if (tipoTopico === TipoTopico.QUESTAO_OBJETIVA || tipoTopico === TipoTopico.QUESTAO_DISCURSIVA) {
                topico.titulo = `${topico.ordemQuestao ? topico.ordemQuestao : index++}ª Questão`
              }
            }

            topico.nomeAbreviado = topico.titulo.length > Constants.TAMANHO_LIMITE_TITULO_TOPICO
              ? topico.titulo.substring(0, Constants.TAMANHO_LIMITE_TITULO_TOPICO) + '...' : topico.titulo
          })
        })
      })

      this.menu = modulos
    }
  }
}
</script>

<style scoped>
</style>
